import { Box, Card, CardBody, CardProps, TextProps, Tooltip } from "@chakra-ui/react";
import { CollecticonCircleInformation } from "@devseed-ui/collecticons-chakra";
import { Overline, ConfidenceTag } from ".";

function MetaDataCard({children, ...props}: CardProps) {
  return (
    <Card {...props}>
      <CardBody display="flex" flexDir="column" gap="1">
        {children}
      </CardBody>
    </Card>
  );
}

export default MetaDataCard;

export function MetaDataHeader({ children, ...props }: TextProps) {
  return (
    <Overline {...props}>{children}</Overline>
  );
}

type Props = {
  label: string;
  value: number | string;
  info?: string | null;
  valueAsTag?: boolean | null;
}

export function MetaData({ label, value, info, valueAsTag }: Props) {
  return (
    <Box display="flex" fontSize="sm" gap="4" alignItems="center">
      <Box as="span" opacity="0.875" flex="1">{label}</Box>
      {valueAsTag ?
        <ConfidenceTag value={value} />
        :
        <Box as="span" fontWeight="500">
          {value}
          {info && (
            <Tooltip label={info}>
              <CollecticonCircleInformation size="3" ml="2" />
            </Tooltip>
          )}
        </Box>}
    </Box>
  );
}
